import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=194c1d6e&"
import script from "./GroupItem.vue?vue&type=script&lang=ts&"
export * from "./GroupItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports